import { useReactiveVar } from '@apollo/client';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import { globalIsDirtyVar } from '../variables';

const GlobalPrompt = () => {
  const { t } = useTranslation();

  const globalIsDirty = useReactiveVar(globalIsDirtyVar);

  return <Prompt when={globalIsDirty} message={t('LeavingWithoutSaving')} />;
};

export default GlobalPrompt;
